// Package imports
import React, { useState, useEffect } from "react";
import _ from "lodash";
import { IconButton } from "@mui/material";
import AudioButton from "../../Media/AudioButton";
import ImageModal from "../../Modal/ImageModal";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";

const audioBtnStyle = {
  color: "#DB8829",
  backgroundColor: "#FFFFFF",
  borderColor: "#EFEFEF",
  backgroundColor: "#FFFFFF",
  boxShadow: 2,
  mx: 1,
  padding: 0,
}

const OptionMedia = (props) => {
  return (
    <>
      {props && props.media && props.media.image && (
        <ImageModal
          src={props.media.image}
          height="100%"
          style={props.sx ? { ...props.sx, borderRadius: 10, objectFit: "contain" } : { borderRadius: 10, objectFit: "contain" }}
        />
      )}
      {props && props.media && props.media.audio && (
        <AudioButton
          expertAudio={props.media.audio}
          playStatus={(status, end) => props.setPlayMode(status, end)}
          disabled={props.disabled}
        >
          <IconButton
            sx={props.sx ? {
              ...props.sx,
              ...audioBtnStyle
            }:{...audioBtnStyle}}
            disabled={props.disabled}
          >
            {props.isPlaying && (
              <PauseIcon
                sx={{
                  borderRadius: "50%",
                  padding: 1,
                  backgroundColor: "#DB8829",
                  color: "#FFFFFF",
                  "@media (min-width: 1636px)": {
                    fontSize: "2.2rem",
                  },
                }}
              />
            )}
            {!props.isPlaying && (
              <MusicNoteIcon
                sx={{
                  borderRadius: "50%",
                  padding: 1,
                  "@media (min-width: 1636px)": {
                    fontSize: "2.2rem",
                  },
                }}
              />
            )}
          </IconButton>
        </AudioButton>
      )}
    </>
  );
};

export default OptionMedia;
